import { createAction, props } from '@ngrx/store';
import { ManureOfferModel } from 'src/app/offer/models/manure-offer.model';
import { ManureRequestModel } from 'src/app/request/models/manure-request.model';
import { ManureFilters } from 'src/app/shared/models/manure-filters.model';

import { OfferOverviewModel, RequestsOverviewModel } from '../../models/overview.model';
import { PageAndSize } from '../../models/paginated-overview.model';

export const loadOffers = createAction(
  '[Offers][Overview] Load offers',
  props<{ paginationOptions: PageAndSize; filters?: ManureFilters }>(),
);

export const loadOffersSuccess = createAction(
  '[Offers][Overview] Load offers success',
  props<{ offersList: ManureOfferModel[]; totalNumberOfOffers: number }>(),
);

export const loadOffersFailure = createAction(
  '[Offers][Overview] Load offers failure',
  props<{ error: string }>(),
);

export const switchToManureOffersOverview = createAction(
  '[Offers][Overview] Switch to Manure Offers Overview Table',
);

export const switchToManureRequestsOverview = createAction(
  '[Requests][Overview] Switch to Manure Requests Overview Table',
);

export const setOverviewOffersLoading = createAction(
  '[Offers][Overview] Set overview offers loading',
  props<{ loading: boolean }>(),
);

export const setOverviewRequestLoading = createAction(
  '[Offers][Overview] Set overview requests loading',
  props<{ loading: boolean }>(),
);

export const loadRequests = createAction(
  '[Requests][Overview] Load requests',
  props<{ paginationOptions: PageAndSize; filters?: ManureFilters }>(),
);

export const loadRequestsSuccess = createAction(
  '[Requests][Overview] Load requests success',
  props<{ requestsList: ManureRequestModel[]; totalNumberOfRequests: number }>(),
);

export const loadRequestsFailure = createAction(
  '[Requests][Overview] Load requests failure',
  props<{ error: string }>(),
);

export const setFilters = createAction(
  '[Filters] Set filters',
  props<{ filters: ManureFilters }>(),
);

export const clearFilters = createAction('[Filters] Clear filters');

export const selectOffer = createAction(
  '[Dashboard] Select Offer',
  props<{ selectedOffer: ManureOfferModel }>(),
);

export const selectRequest = createAction(
  '[Dashboard] Select Request',
  props<{ selectedRequest: ManureRequestModel }>(),
);

export const openOfferOverviewDialog = createAction(
  '[Dashboard] Open offer overview slide-in dialog modal',
  props<{ selectedOffer?: OfferOverviewModel }>(),
);

export const openOfferOverviewDialogSuccess = createAction(
  '[Dashboard] Open offer overview slide-in dialog modal success',
);

export const openRequestOverviewDialog = createAction(
  '[Dashboard] Open request overview slide-in dialog modal',
  props<{ selectedRequest?: RequestsOverviewModel }>(),
);

export const openRequestOverviewDialogSuccess = createAction(
  '[Dashboard] Open request overview slide-in dialog modal success',
);
